const UsersPage = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-primary">Felhasználók</h1>
      <p className="mt-4 text-foreground/80">Itt kezelheted a felhasználókat.</p>
    </div>
  );
};

export default UsersPage;